/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import type { SDKEventAuthenticationFailedV1 } from './SDKEventAuthenticationFailedV1';
import {
    instanceOfSDKEventAuthenticationFailedV1,
    SDKEventAuthenticationFailedV1FromJSON,
    SDKEventAuthenticationFailedV1FromJSONTyped,
    SDKEventAuthenticationFailedV1ToJSON,
} from './SDKEventAuthenticationFailedV1';
import type { SDKEventAuthenticationSucceededV1 } from './SDKEventAuthenticationSucceededV1';
import {
    instanceOfSDKEventAuthenticationSucceededV1,
    SDKEventAuthenticationSucceededV1FromJSON,
    SDKEventAuthenticationSucceededV1FromJSONTyped,
    SDKEventAuthenticationSucceededV1ToJSON,
} from './SDKEventAuthenticationSucceededV1';
import type { SDKEventPersonIdentifiedV1 } from './SDKEventPersonIdentifiedV1';
import {
    instanceOfSDKEventPersonIdentifiedV1,
    SDKEventPersonIdentifiedV1FromJSON,
    SDKEventPersonIdentifiedV1FromJSONTyped,
    SDKEventPersonIdentifiedV1ToJSON,
} from './SDKEventPersonIdentifiedV1';
import type { SDKEventPersonLoggedOutV1 } from './SDKEventPersonLoggedOutV1';
import {
    instanceOfSDKEventPersonLoggedOutV1,
    SDKEventPersonLoggedOutV1FromJSON,
    SDKEventPersonLoggedOutV1FromJSONTyped,
    SDKEventPersonLoggedOutV1ToJSON,
} from './SDKEventPersonLoggedOutV1';
import type { SDKEventSlashIDSDKLoadedV1 } from './SDKEventSlashIDSDKLoadedV1';
import {
    instanceOfSDKEventSlashIDSDKLoadedV1,
    SDKEventSlashIDSDKLoadedV1FromJSON,
    SDKEventSlashIDSDKLoadedV1FromJSONTyped,
    SDKEventSlashIDSDKLoadedV1ToJSON,
} from './SDKEventSlashIDSDKLoadedV1';
import type { SDKEventVirtualPageLoadedV1 } from './SDKEventVirtualPageLoadedV1';
import {
    instanceOfSDKEventVirtualPageLoadedV1,
    SDKEventVirtualPageLoadedV1FromJSON,
    SDKEventVirtualPageLoadedV1FromJSONTyped,
    SDKEventVirtualPageLoadedV1ToJSON,
} from './SDKEventVirtualPageLoadedV1';

/**
 * @type EventPostRequestEventData
 * 
 * @export
 */
export type EventPostRequestEventData = { event_name: 'AuthenticationFailed_v1' } & SDKEventAuthenticationFailedV1 | { event_name: 'AuthenticationSucceeded_v1' } & SDKEventAuthenticationSucceededV1 | { event_name: 'PersonIdentified_v1' } & SDKEventPersonIdentifiedV1 | { event_name: 'PersonLoggedOut_v1' } & SDKEventPersonLoggedOutV1 | { event_name: 'SlashIDSDKLoaded_v1' } & SDKEventSlashIDSDKLoadedV1 | { event_name: 'VirtualPageLoaded_v1' } & SDKEventVirtualPageLoadedV1;

export function EventPostRequestEventDataFromJSON(json: any): EventPostRequestEventData {
    return EventPostRequestEventDataFromJSONTyped(json, false);
}

export function EventPostRequestEventDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventPostRequestEventData {
    if (json == null) {
        return json;
    }
    switch (json['event_name']) {
        case 'AuthenticationFailed_v1':
            return Object.assign({}, SDKEventAuthenticationFailedV1FromJSONTyped(json, true), { event_name: 'AuthenticationFailed_v1' } as const);
        case 'AuthenticationSucceeded_v1':
            return Object.assign({}, SDKEventAuthenticationSucceededV1FromJSONTyped(json, true), { event_name: 'AuthenticationSucceeded_v1' } as const);
        case 'PersonIdentified_v1':
            return Object.assign({}, SDKEventPersonIdentifiedV1FromJSONTyped(json, true), { event_name: 'PersonIdentified_v1' } as const);
        case 'PersonLoggedOut_v1':
            return Object.assign({}, SDKEventPersonLoggedOutV1FromJSONTyped(json, true), { event_name: 'PersonLoggedOut_v1' } as const);
        case 'SlashIDSDKLoaded_v1':
            return Object.assign({}, SDKEventSlashIDSDKLoadedV1FromJSONTyped(json, true), { event_name: 'SlashIDSDKLoaded_v1' } as const);
        case 'VirtualPageLoaded_v1':
            return Object.assign({}, SDKEventVirtualPageLoadedV1FromJSONTyped(json, true), { event_name: 'VirtualPageLoaded_v1' } as const);
        default:
            return json;
    }
}

export function EventPostRequestEventDataToJSON(json: any): any {
    return EventPostRequestEventDataToJSONTyped(json, false);
}

export function EventPostRequestEventDataToJSONTyped(value?: EventPostRequestEventData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['event_name']) {
        case 'AuthenticationFailed_v1':
            return Object.assign({}, SDKEventAuthenticationFailedV1ToJSON(value), { event_name: 'AuthenticationFailed_v1' } as const);
        case 'AuthenticationSucceeded_v1':
            return Object.assign({}, SDKEventAuthenticationSucceededV1ToJSON(value), { event_name: 'AuthenticationSucceeded_v1' } as const);
        case 'PersonIdentified_v1':
            return Object.assign({}, SDKEventPersonIdentifiedV1ToJSON(value), { event_name: 'PersonIdentified_v1' } as const);
        case 'PersonLoggedOut_v1':
            return Object.assign({}, SDKEventPersonLoggedOutV1ToJSON(value), { event_name: 'PersonLoggedOut_v1' } as const);
        case 'SlashIDSDKLoaded_v1':
            return Object.assign({}, SDKEventSlashIDSDKLoadedV1ToJSON(value), { event_name: 'SlashIDSDKLoaded_v1' } as const);
        case 'VirtualPageLoaded_v1':
            return Object.assign({}, SDKEventVirtualPageLoadedV1ToJSON(value), { event_name: 'VirtualPageLoaded_v1' } as const);
        default:
            return value;
    }
}

